<div class="filter app-filter-single-select-container full-width">
  <mat-label class="mat-label">{{ filter.name }}</mat-label>
  <mat-form-field floatLabel="never">
    <mat-select (selectionChange)="updateSelected($event.value)" placeholder="Veuillez choisir une valeur">
      <mat-option>Tous</mat-option>
      <mat-option *ngFor="let filterOption of filter.options" [value]="filterOption">{{ filterOption.name }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
